import { track } from './analytics';
import type { StoredResult } from './storage';

export function shareText(puzzle: number, result: StoredResult, streak: number, origin = 'closeout.playkeg.com'): string {
  const journey = result.journey.map((shot) => {
    const mark = shot.made ? '◉' : '◌';
    const value = shot.value === 2 ? '²' : shot.value === 3 ? '³' : '·';
    return `${mark}${value}`;
  }).join(' ');
  const lines = [
    `CLOSEOUT #${String(puzzle).padStart(3, '0')}`,
    `${result.score} PTS · ${(result.timeLeftTenths / 10).toFixed(1)} LEFT · ${result.tier.toUpperCase()}`,
    '',
    journey,
  ];
  if (streak >= 2) lines.push(`🔥 ${streak} · ${origin}`);
  else lines.push(origin);
  return lines.join('\n');
}

export async function shareResult(text: string): Promise<'native' | 'clipboard' | 'fallback' | 'dismissed'> {
  track('share_clicked');
  if (navigator.share) {
    try {
      await navigator.share({ text });
      track('share', { method: 'native' });
      return 'native';
    } catch {
      track('share_dismissed');
      return 'dismissed';
    }
  }
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      track('share', { method: 'clipboard' });
      return 'clipboard';
    } catch {
      // Fall through for older iOS / denied clipboard permission.
    }
  }
  const area = document.createElement('textarea');
  area.value = text;
  area.readOnly = true;
  area.style.cssText = 'position:fixed;top:-1000px;opacity:0';
  document.body.append(area);
  area.select();
  area.setSelectionRange(0, text.length);
  try { document.execCommand('copy'); } catch { /* no remaining fallback */ }
  area.remove();
  track('share', { method: 'copy-fallback' });
  return 'fallback';
}
